import { openShareDialog } from 'reactApp/appHelpers/appHelpers';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { store as reduxStore } from 'reactApp/store';
import { renderCreateShareDialog } from 'reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit';
import { sendXray } from 'reactApp/utils/ga';

import { emitAnalyticEvent } from '../experimentAnalytic';
import { AnalyticEventNames } from '../experimentAnalytic/eventNames';
import { getSelectedItemsOrCurrentFolder } from './helpers/getSelectedItemsOrCurrentFolder';

export const share = (id?: string): void => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItemsOrCurrentFolder();
    const item = (id && getItemById(state, id)) || (selectedItems.length === 1 && selectedItems[0]);

    if ((item && item.id === '/') || !selectedItems.length) {
        renderCreateShareDialog({
            onSuccess: (item) => openShareDialog({ item }),
        });
        return;
    }

    emitAnalyticEvent(AnalyticEventNames.BREADCRUMBS_PUBLISH_CLICK);
    sendXray('breadcrumbs_publish-click');
    openShareDialog({ item });
};
